import { Form, Row } from 'antd';
import React from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import FormWrapper from 'components/molecules/FormWrapper';

import { useDateLimit } from 'hooks/statniSprava/useDateLimit';
import { useFormBasics } from 'hooks/statniSprava/useFormBasics';

import kategorieRoleSelect from 'data/codebooks/statniSprava/pozadavkyRoleSelect';

import AlertComponent from './AlertComponent';
import OdeslaniPozadavkuRows from './odeslaniPozadavkuRows';

interface IF52 {}

const F52: React.FC<IF52> = () => {
    const [form] = Form.useForm();
    const [, dateLoading, commonDisabledDate] = useDateLimit();

    const [
        errMsg,
        currentStep,
        idSluzby,
        upozorneni,
        loading,
        odeslaniResp,
        setErrMsg,
        prev,
        onFormSubmit,
        showPxKlicLoadingMsg
    ] = useFormBasics();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        const dataToSend = {
            ...fieldsValue,
            dtod: fieldsValue.dtod.format('YYYY-MM-DD'),
            dtdo: fieldsValue.dtdo.format('YYYY-MM-DD')
        };
        onFormSubmit(dataToSend);
    };

    return (
        <LoadingWrapper loading={loading} loadingText={showPxKlicLoadingMsg ? 'LOADING_PXKLIC' : 'NACITANI'}>
            <Title level={4} text="DUVERNE_INFO_TITLE_F52" />{' '}
            {errMsg ? (
                <>
                    <Paragraph text={errMsg} />
                    <Row>
                        <ButtonComponent
                            id="f52ZpetBtn"
                            type="default"
                            buttontext="ZPET"
                            onClick={() => setErrMsg('')}
                        />
                    </Row>
                </>
            ) : (
                <>
                    {currentStep !== 2 ? (
                        <FormWrapper onFinish={onFinish} outForm={form}>
                            <>
                                <LoadingWrapper loading={dateLoading}>
                                    <DatePickerComponent
                                        name="dtod"
                                        label="ME_POZADAVKY_DATUM1"
                                        disabled={currentStep > 0}
                                        disabledDate={current =>
                                            current > form.getFieldValue('dtdo') || commonDisabledDate(current)
                                        }
                                    />
                                    <DatePickerComponent
                                        name="dtdo"
                                        disabled={currentStep > 0}
                                        label="ME_POZADAVKY_DATUM2"
                                        disabledDate={current =>
                                            current < form.getFieldValue('dtod') || commonDisabledDate(current)
                                        }
                                    />
                                </LoadingWrapper>
                                <InputComponent
                                    label={'ME_POZADAVKY_IDENTIFIKATOR_OSOBYCDCP'}
                                    name="idma"
                                    type="text"
                                    maxLength={100}
                                    notRequired={true}
                                    hide={currentStep === 1 && !form.getFieldValue('idma')}
                                    disabled={currentStep > 0}
                                />

                                <SelectComponent
                                    disabled={currentStep > 0}
                                    name="rosb"
                                    labelParagraph="ME_POZADAVKY_ROLE"
                                    labelCol={{
                                        span: 8
                                    }}
                                    data={kategorieRoleSelect}
                                    defaultValue={kategorieRoleSelect[0].value}
                                    isFormItem={true}
                                    notRequired={true}
                                    hide={currentStep === 1 && !form.getFieldValue('rosb')}
                                />

                                {currentStep === 0 && (
                                    <ButtonComponent
                                        id="f52OdeslatBtn"
                                        buttontext="ODESLAT"
                                        onClick={() => form.submit()}
                                    />
                                )}
                                {currentStep !== 0 && upozorneni && (
                                    <AlertComponent
                                        upozorneni={upozorneni}
                                        type={currentStep === 1 ? 'error' : 'info'}
                                    />
                                )}
                                {currentStep === 1 && (
                                    <Row className="button-row">
                                        <ButtonComponent
                                            id="f52ZpetAltBtn"
                                            buttontext="ZPET"
                                            onClick={() => prev()}
                                            type="default"
                                        />
                                        <ButtonComponent
                                            id="f52PotvrditBtn"
                                            buttontext="POTVRDIT"
                                            onClick={() => form.submit()}
                                        />
                                    </Row>
                                )}
                            </>
                        </FormWrapper>
                    ) : (
                        <>
                            <OdeslaniPozadavkuRows idSluzby={idSluzby} datum={odeslaniResp?.datum} />
                            {upozorneni && <AlertComponent upozorneni={upozorneni} type={'info'} />}
                        </>
                    )}{' '}
                </>
            )}
        </LoadingWrapper>
    );
};

export default F52;
